<template>
  <section class="container">
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      注：工作人员将在3-5个工作日之内与您联系，请保持电话畅通
    </van-notice-bar>
    <div class="result_content">
      <!-- <van-icon name="checked" :size="100" color="#07c160" class="result_icon" /> -->
      <van-image :src="result_icon" class="result_icon">
        <template v-slot:loading>
          <van-loading type="spinner" size="100" />
        </template>
      </van-image>
      <div class="result_title">{{ result_title }}</div>
      <div class="result_info">产品名称：{{ result_info }}</div>
    </div>
    <div class="button_box">
      <van-button type="info" size="large" to="vehicle-insurance"
        >完成</van-button
      >
    </div>
    <van-divider>
      <div style="text-align:center;">
        Copyright ©
        {{
          $enumObject.providerConfig[config.projectName].copyrightInfo.subject
        }}
        <br />
      </div>
    </van-divider>
  </section>
</template>

<script>
import { Icon, NoticeBar, Divider } from 'vant'
import result_icon from '@/assets/insurance_images/result_icon.png'
import config from '@/config/index'
export default {
  name: 'Result-Page',
  components: {
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Divider.name]: Divider
  },
  data() {
    return {
      config,
      result_icon,
      result_title: '出单成功',
      result_info: '汽车玻璃保'
    }
  }
}
</script>

<style lang="scss" scoped>
.result_content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 65vh;
  text-align: center;
  .result_icon {
    width: 120px;
    height: auto;
    margin: 0 auto 20px;
  }
  .result_title {
    height: 40px;
    line-height: 40px;
    font-size: 24px;
  }
  .result_info {
    line-height: 30px;
    font-size: 16px;
  }
}
.button_box {
  padding: 0 10px 0;
}
</style>
